import { TState } from '@r1-frontend/entities/stores/city/reducer';

const selectProviderId = (state: TState): number => state.city.provider.providerId;

export default selectProviderId;
